module.exports = __webpack_public_path__ + "static/media/logoBg.7193d533.png";